export default __webpack_public_path__ + "static/media/PF_06.ecdb9889.png";